import React, { useEffect, useState } from "react";
import "../DesignJobs/index.scss";
import PageLayout from "../../PageLayout";
import DesignHeader from "../DesignJobs/DesignHeader";
import AddNewDesign from "../DesignJobs/TaskHeader";
import AddNewDesignContent from "../DesignJobs/AddNewDesignContent";
import FooterButtons from "../DesignJobs/FooterButtons";
import { ProjectService } from "../../../service/PegaService";
import { useSelector } from "react-redux";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";

const breadcrumb = [{ label: "My Tasks", url: "/myTasks" }, { label: "Produciton Ready Art" }];


function DCD() {
  const [data, setData] = useState(null);
  const [designIntent, setDesignIntent] = useState([]);
  const [updated, setUpdated] = useState(false);
  const [submittedDI, setSubmittedDI] = useState([]);
  const { TaskDetailsData } = useSelector((state) => state.TaskDetailsReducer);
  const headerName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.TaskPlaceholderName;
  let checkTaskIsComplete = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "Complete" || TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "Cancelled";

  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);

  useEffect(()=>{
    markClean();
    setPageEdited (false);
  },[]);

  useEffect(() => {
    const data1 = ProjectService.getDIData();
    setData(data1);

    setDesignIntent(data1.DesignIntentList);
  }, [data]);

  const handleDelete = (index) => {
    const sub = designIntent.filter((i) => i !== index);

    setDesignIntent(sub);
  };

  const addNewEmptyDesign = () => {
    designIntent.push({
      DesignJobid: designIntent.length + 1,
      isNew: true,
      AgencyReference: "",
      Cluster: "",
      AdditionalInfo: "",
    });
    setDesignIntent(designIntent);
    setUpdated(!updated);
  };

  const addData = (fieldName, index, value, Design_Intent_Name) => {
    let data = designIntent[index];
    data[fieldName] = value;
    data["Design_Intent_Name"] = Design_Intent_Name;
    submittedDI.push(data);
    setSubmittedDI(submittedDI);
  };

  const onSelectAll = (checked) => {
    designIntent.map((task) => {
      if (task?.event !== "submit") {
        task.Select = checked;
      }
      return task;
    });
    setDesignIntent(designIntent);
    setUpdated(!updated);
  };

  const onSubmit = () => {
    let submitOnlySelectedData = designIntent.filter((task) => task?.Select === true);
    submitOnlySelectedData.map((task) => {
      task.event = "submit";
    });
  };

  const onSaveAsDraft = () => {
    let submitOnlySelectedData = designIntent.filter((task) => task?.event !== "submit");
    submitOnlySelectedData.map((task) => {
      task?.DesignJobid ? (task.action = "update") : (task.action = "add");
      task.event = "draft";
    });
  };

  const handleCancel = () =>{}

  const handleCancelClick = () =>{
    if(pageEdited){
      setShowDialog(true);
    }else{
      handleCancel();
    }
  }

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  }
  // it will navigate to previously saved url navigate(pendingNavigation);
  // by doing setShowDialog(false) and setPendingNavigation("");
  const confirmNavigation = () => {
    markClean();
    handleCancel();
    setPageEdited(false);
    setShowDialog(false);
  }

  return (
    <PageLayout>
      <DesignHeader
        setAddNewDesign={addNewEmptyDesign}
        onSelectAll={onSelectAll}
        breadcrumb={breadcrumb}
        headerName={headerName}
        lastLabel={"DCD"}
        pageEdited={pageEdited}
        setPageEdited={setPageEdited}
        checkTaskISComplete={checkTaskIsComplete}
      />
      <div
        style={{
          overflowY: "scroll",
          overflowX: "hidden",
          width: "100%",
          height: "400px",
        }}
      >
        {<AddNewDesign {...data} TaskDetailsData={TaskDetailsData} pageEdited={pageEdited} setPageEdited={setPageEdited} />}

        {designIntent &&
          designIntent.length &&
          designIntent.map((item, index) => {
            return (
              <AddNewDesignContent
                key={item.DesignJobid}
                {...data}
                item={item}
                AWMProjectID={TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}
                AWMTaskID={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_ID}
                Bu={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU}
                Region={TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Region}
                isTaskComplete={checkTaskIsComplete}
                hideClearButton={false}
                index={index}
                pageEdited={pageEdited}
                setPageEdited={setPageEdited}
                addData={addData}
                handleDelete={handleDelete}
              />
            );
          })}
        <FooterButtons onSaveAsDraft={onSaveAsDraft} onSubmit={onSubmit} handleCancel={handleCancelClick} />
      </div>
      {/* UnsavedChangesDialog popup*/}   
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
    </PageLayout>
  );
}

export default DCD;
